import { Avatar, Button, Grid, ListItemAvatar, ListItemButton, ListItemText } from '@mui/material'
import React from 'react'
import logoplay from "../Images/playstore.png"

export default function DescargarApp() {

    const abrirAppFuera = () => {
        window.open("https://play.google.com/store/apps/details?id=com.jhonmorales.jchessmanager");
    }

    return (
        <div>
            <p>
                ¡Descarga nuestra Aplicación y accede a todas las funciones!
            </p>

            <Grid container spacing={2}>
                <Grid item>
                    <ListItemButton onClick={() => { abrirAppFuera() }}>
                        <ListItemAvatar>
                            <Avatar alt="Cubolandia" src={logoplay} />
                        </ListItemAvatar>
                        <ListItemText primary={"JChess Manager"} secondary={"Disponible en Google Play"} />
                    </ListItemButton>
                </Grid>
            </Grid>

        </div>
    )
}
